import { Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import Loading from '../../../../components/Loading';
import { useGetServices } from '../../../../hooks/data/services';
import { ServiceRow } from '../ServiceRow';

const ServicesTable: React.FC = () => {
  const { data, status } = useGetServices();

  const getMainContent = useCallback(() => {
    if (status === 'loading') {
      return <Loading />;
    }

    if (status !== 'success') {
      return <p>Erro ao buscar os serviços. Tente novamente</p>;
    }

    if (data?.length === 0) {
      return <Typography>Você não possui serviços cadastrados.</Typography>;
    }

    return data?.map(row => <ServiceRow key={row.id} service={row} />);
  }, [data, status]);

  return <>{getMainContent()}</>;
};

export { ServicesTable };
